import { render, staticRenderFns } from "./RouterSidebar.vue?vue&type=template&id=5dc0f672&"
import script from "./RouterSidebar.vue?vue&type=script&lang=js&"
export * from "./RouterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RouterSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports